export { default } from './privacy';